import { useMemo, useState } from "react";
import { TbArrowLeft, TbSearch, TbUsers } from "react-icons/tb";
import { PIX_FAVORITE_CONTACTS } from "../../../Pages/Private/Pix/PixTransfers/pixFavoriteContacts";

const getInitials = (name = "") => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return (parts[0]?.[0] ?? "?").toUpperCase();
};

export const PixContactPickerTrigger = ({ onOpen }) => {
  if (!PIX_FAVORITE_CONTACTS.length) return null;

  return (
    <button
      type="button"
      onClick={onOpen}
      className="pix-transfer-link"
    >
      <TbUsers className="h-3.5 w-3.5" />
      Favorecidos
    </button>
  );
};

export const PixContactPickerPanel = ({ onBack, onSelect, selectedId }) => {
  const [search, setSearch] = useState("");

  const filteredContacts = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return PIX_FAVORITE_CONTACTS;

    return PIX_FAVORITE_CONTACTS.filter(
      (contact) =>
        contact.name.toLowerCase().includes(query) ||
        contact.bankName.toLowerCase().includes(query) ||
        contact.pixKeyDisplay.toLowerCase().includes(query)
    );
  }, [search]);

  if (!PIX_FAVORITE_CONTACTS.length) return null;

  return (
    <div className="pix-transfer-contacts-panel">
      <div className="border-b border-gray-100 pb-4">
        <button
          type="button"
          onClick={onBack}
          className="btn-back w-auto"
          aria-label="Voltar para destino"
        >
          <TbArrowLeft className="h-4 w-4" />
          Voltar
        </button>
      </div>

      <div className="relative mt-4">
        <TbSearch
          className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
          aria-hidden
        />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar por nome, banco ou chave..."
          className="valut-input h-11 w-full rounded-xl pl-9 pr-3"
          autoFocus
        />
      </div>

      <ul className="pix-transfer-contacts-panel__list mt-3" role="listbox" aria-label="Favorecidos">
        {filteredContacts.length === 0 ? (
          <li className="px-2 py-8 text-center text-sm text-gray-400">
            Nenhum favorecido encontrado.
          </li>
        ) : (
          filteredContacts.map((contact) => {
            const isSelected = selectedId === contact.id;

            return (
              <li key={contact.id}>
                <button
                  type="button"
                  role="option"
                  aria-selected={isSelected}
                  onClick={() => onSelect(contact)}
                  className={`pix-transfer-contacts-panel__item${isSelected ? " pix-transfer-contacts-panel__item--selected" : ""}`}
                >
                  <span className="pix-transfer-contacts__avatar" aria-hidden>
                    {getInitials(contact.name)}
                  </span>
                  <span className="min-w-0 flex-1 text-left">
                    <span className="block truncate text-sm font-semibold text-brand-dark">
                      {contact.name}
                    </span>
                    <span className="block truncate text-xs text-gray-500">{contact.bankName}</span>
                    <span className="block truncate text-xs text-gray-400">{contact.pixKeyDisplay}</span>
                  </span>
                </button>
              </li>
            );
          })
        )}
      </ul>
    </div>
  );
};
